import React, { memo } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
export default /*#__PURE__*/memo(_ref => {
  let {
    width = '150px',
    height = '150px',
    src
  } = _ref;
  return /*#__PURE__*/React.createElement(Player, {
    autoplay: true,
    loop: true,
    src: src,
    style: {
      height,
      width
    }
  });
});